<template>
  <div class="content-box">
    <template v-if="icon === 'kkld'">
      <img
        class="img-border"
        src="../../../assets/images/开口铆钉.png"
        alt=""
      />
      <p class="content-box-title">开口铆钉</p>
      <p class="content-box-text">
        西河开口铆钉，实现单面铆接的功能，提供多样的材质选择。
      </p>
    </template>
    <template v-else-if="icon === 'sgld'">
      <img
        class="img-border"
        src="../../../assets/images/双鼓铆钉.png"
        alt=""
      />
      <p class="content-box-title">双鼓铆钉</p>
      <p class="content-box-text">
        西河双鼓铆钉，多鼓的膨胀方式，提供更大的铆接范围，适用于不同厚度的工件。
      </p>
    </template>
    <template v-else-if="icon === 'nsld'">
      <img
        class="img-border"
        src="../../../assets/images/双鼓铆钉.png"
        alt=""
      />
      <p class="content-box-title">内锁铆钉</p>
      <p class="content-box-text">
        西河内锁铆钉，为需要高强度的抗拉力和抗剪力的应用而设计，保证钉芯锁紧。
      </p>
    </template>
    <template v-else-if="icon === 'wsld'">
      <img
        class="img-border"
        src="../../../assets/images/双鼓铆钉.png"
        alt=""
      />
      <p class="content-box-title">外锁铆钉</p>
      <p class="content-box-text">
        西河内锁铆钉，为需要高强度的抗拉力和抗剪力的应用而设计，保证钉芯锁紧。
      </p>
    </template>
    <template v-else-if="icon === 'hmld'">
      <img class="img-border" src="../../../assets/images/gf3.png" alt="" />
      <p class="content-box-title">海马铆钉</p>
      <p class="content-box-text">
        西河海马铆钉，采用花键式紧锁钉芯的结构设计，提供强大的防震链接。
      </p>
    </template>
    <template v-else-if="icon === 'dcbjgfa'">
      <img
        class="img-border"
        src="../../../assets/images/双鼓铆钉.png"
        alt=""
      />
      <p class="content-box-title">电池包紧固方案</p>
      <p class="content-box-text">
        西河双鼓铆钉，多鼓的膨胀方式，提供更大的铆接范围，适用于不同厚度的工件。
      </p>
    </template>
    <template v-else-if="icon === 'ktcfkjgfa'">
      <img
        class="img-border"
        src="../../../assets/images/双鼓铆钉.png"
        alt=""
      />
      <p class="content-box-title">空调出风口紧固方案</p>
      <p class="content-box-text">
        采用三片式折叠的设计理念，达到更低的夹紧力，有效解决了塑料复合材料等软性易碎材料的铆接问题。
      </p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "kkld"
    }
  }
};
</script>

<style lang="scss">
.content-box {
  width: 45%;
  height: 3rem;
  max-height: 270px;
  background: url("../../../assets/images/content_box_bg.png") no-repeat 100%
    100%;
  background-size: cover;
  padding: 0;
  position: relative;
  padding-right: 0.5rem;
  box-sizing: border-box;
  .img-border {
    width: 0.5rem;
    height: 80%;
    top: 10%;
    position: absolute;
    left: -0.25rem;
  }
  &-title {
    color: rgba(253, 130, 4, 1);
    font-size: 0.2rem;
    font-weight: 700;
    margin-left: 1.5rem;
    margin-top: 0.8rem;
    letter-spacing: 0px;
  }
  &-text {
    color: rgba(253, 130, 4, 1);
    font-size: 0.16rem;
    color: rgba(102, 102, 102, 1);
    margin-left: 1.5rem;
    line-height: 0.3rem;
    margin-top: 0.3rem;
    letter-spacing: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/content-box/index.vue